import { useEffect } from 'react';
import { useToast } from '../context/ToastContext';

/**
 * Глобальные toast-сообщения через CustomEvent (для компонентов без прямого доступа к контексту).
 * dispatch: window.dispatchEvent(new CustomEvent('app:toast', { detail: { message, type: 'warning' } }))
 */
const ToastEventListener = () => {
  const { showSuccess, showError, showWarning, showInfo } = useToast();

  useEffect(() => {
    const handler = (e) => {
      const { message, type = 'info' } = e.detail || {};
      if (!message) return;
      const fn = { success: showSuccess, error: showError, warning: showWarning, info: showInfo }[type] || showInfo;
      fn(message);
    };
    window.addEventListener('app:toast', handler);
    return () => window.removeEventListener('app:toast', handler);
  }, [showSuccess, showError, showWarning, showInfo]);

  return null;
};

export default ToastEventListener;
